<template>
  <b-modal
    :id="modalId"
    :title="$t('SERVICE_VISITS.COMPLETION_DETAILS_TITLE')"
    :ok-title="$t('BUTTON.READY')"
    :cancel-title="$t('BUTTON.CANCEL')"
    :ok-disabled="!areCompletionDetailsValid || saving"
    @ok.prevent="complete"
    @hidden="reset"
  >
    <b-form-group :label="completionMileageLabel">
      <b-form-input
        v-model="serviceMileage"
        type="number"
        min="0"
        step="1"
        autofocus
      />
    </b-form-group>
    <b-form-group :label="$t('SERVICE_VISITS.HOURS_WORKED')">
      <b-form-input
        v-model="hoursWorked"
        type="number"
        min="0"
        step="0.25"
      />
    </b-form-group>
    <b-form-group :label="$t('SERVICE_VISITS.WORK_DONE')">
      <b-form-textarea
        v-model="workDone"
        rows="2"
        max-rows="5"
        maxlength="5000"
        :placeholder="$t('SERVICE_VISITS.WORK_DONE')"
      />
    </b-form-group>
  </b-modal>
</template>

<script>
export default {
  name: "ServiceVisitCompletionModal",
  props: {
    modalId: {
      type: String,
      required: true
    },
    visit: {
      type: Object,
      default: null
    },
    saving: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      serviceMileage: null,
      hoursWorked: null,
      workDone: null
    };
  },
  computed: {
    isCompletionMileageValid() {
      return (
        this.serviceMileage !== null &&
        this.serviceMileage !== "" &&
        Number.isInteger(Number(this.serviceMileage)) &&
        Number(this.serviceMileage) >= 0
      );
    },
    isCompletionHoursWorkedValid() {
      return (
        this.hoursWorked !== null &&
        this.hoursWorked !== "" &&
        Number(this.hoursWorked) >= 0
      );
    },
    areCompletionDetailsValid() {
      return this.isCompletionMileageValid && this.isCompletionHoursWorkedValid;
    },
    completionMileageLabel() {
      return this.visit && this.visit.machine && this.visit.machine.isMileage
        ? this.$t("SERVICE_VISITS.COMPLETION_KILOMETERS")
        : this.$t("SERVICE_VISITS.COMPLETION_MOTO_HOURS");
    }
  },
  methods: {
    open() {
      this.resetFields();
      this.$nextTick(() => this.$bvModal.show(this.modalId));
    },
    close() {
      this.$bvModal.hide(this.modalId);
    },
    complete() {
      if (!this.areCompletionDetailsValid || this.saving) {
        return;
      }

      this.$emit("complete", {
        serviceMileage: Number(this.serviceMileage),
        hoursWorked: Number(this.hoursWorked),
        workDone: this.workDone ? this.workDone.trim() : null
      });
    },
    reset() {
      this.resetFields();
      this.$emit("hidden");
    },
    resetFields() {
      this.serviceMileage = null;
      this.hoursWorked = null;
      this.workDone = null;
    }
  }
};
</script>
